<template>
    <div class="new-customer-dialog">
        <el-dialog
            class="customer-dialog"
            :visible.sync="visible"
            :title="tip ? $t('Client.Add.edit') : $t('Client.Add.new')"
            left>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="106px"
                label-suffix=":">
                <div class="flex justify-between">
                    <div class="flex">
                        <div>
                            <el-form-item :label="$t('Common.name')" prop="name">
                                <el-input
                                    v-model="form.name"
                                    :placeholder="$t('Common.name_placeholder')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('Common.phone_number')" prop="phone">
                                <el-input
                                    v-enter-number2
                                    :disabled="tip && !$$filterPermission('客户-客户/会员管理-修改手机号')"
                                    maxlength="11"
                                    v-model="form.phone"
                                    :placeholder="$t('Common.phone_placeholder')">
                                </el-input>
                            </el-form-item>
                            <el-form-item :label="$t('Common.wechat')">
                                <el-input
                                    v-model="form.wechat"
                                    :placeholder="$t('Common.wechat_placeholder')"></el-input>
                            </el-form-item>
                            <el-form-item
                                :label="$t('Common.bind_physical')"
                                label-width="130px"
                                v-if="tip">
                                <el-input
                                    v-if="form.cardPhysicalId"
                                    disabled
                                    style="width:250px"
                                    v-model="form.cardPhysicalId"
                                    :placeholder="$t('Common.click_bind_physical')"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item
                                :label="$t('Common.gender')"
                                prop="genderCode">
                                <el-radio-group v-model="form.genderCode">
                                    <el-radio :label="1">{{ $t('Common.male') }}</el-radio>
                                    <el-radio :label="2">{{ $t('Common.female') }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item :label="$t('Common.birthday')">
                                <el-date-picker
                                    v-model="form.birthday"
                                    type="date"
                                    :placeholder="$t('Common.birthday_placeholder')">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item :label="$t('Common.card_number')" v-if="tip" prop="cardNum">
                                <el-input
                                    disabled
                                    v-if="form.cardNum"
                                    v-model="form.cardNum"
                                    :placeholder="$t('Common.card_number_placeholder')"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div>
                        <div class="avator-bg flex items-center justify-center">
                            <div
                                v-if="!form.avatar"
                                class="iconfont icon-fitness-touxiang2"></div>
                            <div
                                v-if="form.avatar"
                                class="avatar"
                                :style="`background-image: url(${form.avatar})`"></div>
                        </div>
                        <div class="flex justify-between">
                            <div class="camera">{{ $t('Common.take_phone') }}</div>
                            <file-upload class="abcd" @input="addImg(arguments)">
                                <div>{{ $t('Common.upload') }}</div>
                            </file-upload>
                        </div>
                    </div>
                </div>
                <div class="customer-line"></div>
                <div class="flex">
                    <el-form-item
                        :label="$t('Common.distribution_saler')"
                        prop="mshpSalesId">
                        <el-select
                            class="pr-2"
                            v-model="form.mshpSalesId"
                            :placeholder="$t('Common.distribution_saler_placeholder')">
                            <input
                                class="search-input-all"
                                type="text"
                                v-model="searchText" >
                            <el-option
                                v-for="item in filterList"
                                :key="item.id"
                                :label="item.nickname"
                                :value="Number(item.id)"
                                :disabled="!item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        :label="$t('Client.Add.attributes')"
                        prop="channelAttrCode">
                        <el-select
                            class="pr-2"
                            v-model="form.channelAttrCode"
                            :placeholder="$t('Client.Add.attributes_placeholder')">
                            <el-option
                                v-for="(item,index) in select.channel"
                                :key="`channel-${index}`"
                                :label="item.name"
                                :value="Number(item.code)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="flex">
                    <el-form-item
                        :label="$t('Client.Add.get_attributes')"
                        prop="channelSourceCode">
                        <el-select
                            class="pr-2"
                            v-model="form.channelSourceCode"
                            :placeholder="$t('Client.Add.get_attributes_placeholder')">
                            <el-option
                                v-for="item in select.channelCode"
                                :key="item.code"
                                :label="item.name"
                                :value="Number(item.code)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Client.Add.follow_level')">
                        <el-select
                            class="pr-2"
                            v-model="form.followLevelCode"
                            :placeholder="$t('Client.Add.follow_level_placeholder')">
                            <el-option
                                v-for="item in select.level"
                                :key="item.code"
                                :label="item.name"
                                :value="Number(item.code)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="flex flex-wrap">
                    <el-form-item :label="$t('Client.Add.channel_area')">
                        <el-select
                            v-on:change="selectProvince(form.provinceId, 'origin')"
                            @change="$set(form, 'districtId', null), $set(form, 'cityId', null)"
                            class="pr-2 customer-area"
                            v-model="form.provinceId"
                            :placeholder="$t('Client.Add.province_placeholder')">
                            <el-option
                                v-for="item in select.province"
                                :key="item.id"
                                :label="item.fullname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select
                            v-on:change="selectCity(form.cityId, 'origin', form.provinceId)"
                            @change="form.districtId = null"
                            class="pr-2 customer-area"
                            v-model="form.cityId"
                            :placeholder="$t('Client.Add.city_placeholder')">
                            <el-option
                                v-for="item in select.city"
                                :key="item.id"
                                :label="item.fullname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select
                            class="pr-2 customer-area"
                            v-model="form.districtId"
                            :placeholder="$t('Client.Add.district_placeholder')">
                            <el-option
                                v-for="item in select.district"
                                :key="item.id"
                                :label="item.fullname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="customer-line"></div>
                <div class="flex">
                    <el-form-item :label="$t('Client.Add.certificate_type')">
                        <el-select
                            class="pr-2"
                            v-model="form.certTypeCode"
                            :placeholder="$t('Client.Add.certificate_type_placeholder')">
                            <el-option
                                v-for="item in select.certType"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Client.Add.certificate_number')">
                        <el-input
                            class="customer-num"
                            v-model="form.certNum"
                            :placeholder="$t('Client.Add.certificate_number_placeholder')">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="flex">
                    <el-form-item :label="$t('Client.Add.Country_of_Citizenship')">
                        <el-input
                            type="text"
                            v-model="form.citizenship"
                            :placeholder="$t('Client.Add.Country_of_Citizenship_placeholder')">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Client.Add.nation')">
                        <el-select
                            class="pr-2"
                            v-model="form.nationCode"
                            :placeholder="$t('Client.Add.nation_placeholder')">
                            <el-option
                                v-for="item in select.nation"
                                :key="item.code"
                                :label="item.name"
                                :value="Number(item.code)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Client.Add.career')">
                        <el-input
                            type="text"
                            v-model="form.career"
                            :placeholder="$t('Client.Add.career_placeholder')"></el-input>
                    </el-form-item>
                </div>
                <el-form-item label="E-mail">
                    <el-input
                        type="text"
                        class="customer-email"
                        v-model="form.email"
                        :placeholder="$t('Client.Add.email_placeholder')">
                    </el-input>
                </el-form-item>
                <div class="flex flex-wrap">
                    <el-form-item :label="$t('Client.Add.family_address')">
                        <el-select
                            v-on:change="selectProvince(form.homeProvinceId, 'home')"
                            @change="$set(form, 'homeCityId', null), $set(form, 'homeDistrictId', null)"
                            class="pr-2 customer-area"
                            v-model="form.homeProvinceId"
                            :placeholder="$t('Client.Add.province_placeholder')">
                            <el-option
                                v-for="item in select.homeProvince"
                                :key="item.id"
                                :label="item.fullname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select
                            v-on:change="selectCity(form.homeCityId, 'home', form.homeProvinceId)"
                            class="pr-2 customer-area"
                            @change="form.homeDistrictId = null"
                            v-model="form.homeCityId"
                            :placeholder="$t('Client.Add.city_placeholder')">
                            <el-option
                                v-for="item in select.homeCity"
                                :key="item.id"
                                :label="item.fullname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select
                            class="pr-2 customer-area"
                            v-model="form.homeDistrictId"
                            :placeholder="$t('Client.Add.district_placeholder')">
                            <el-option
                                v-for="item in select.homeDistrict"
                                :key="item.id"
                                :label="item.fullname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input
                            class="customer-address"
                            type="text"
                            :placeholder="$t('Client.Add.address_placeholder')"
                            v-model="form.homeAddress">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="flex">
                    <el-form-item :label="$t('Client.Add.company_name')">
                        <el-input
                            type="text"
                            v-model="form.companyName"
                            :placeholder="$t('Client.Add.company_name_placeholder')">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Client.Add.company_phone')">
                        <el-input
                            type="text"
                            v-model="form.companyPhone"
                            :placeholder="$t('Client.Add.company_phone_placeholder')">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="flex flex-wrap">
                    <el-form-item :label="$t('Client.Add.work_address')">
                        <el-select
                            v-on:change="selectProvince(form.workProvinceId, 'work')"
                            @change="$set(form, 'workCityId', null), $set(form, 'workDistrictId', null)"
                            class="pr-2 customer-area"
                            v-model="form.workProvinceId"
                            :placeholder="$t('Client.Add.province_placeholder')">
                            <el-option
                                v-for="item in select.workProvince"
                                :key="item.id"
                                :label="item.fullname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select
                            v-on:change="selectCity(form.workCityId, 'work', form.workProvinceId)"
                            @change="form.workDistrictId = null"
                            class="pr-2 customer-area"
                            v-model="form.workCityId"
                            :placeholder="$t('Client.Add.city_placeholder')">
                            <el-option
                                v-for="item in select.workCity"
                                :key="item.id"
                                :label="item.fullname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select
                            class="pr-2 customer-area"
                            v-model="form.workDistrictId"
                            :placeholder="$t('Client.Add.district_placeholder')">
                            <el-option
                                v-for="item in select.workDistrict"
                                :key="item.id"
                                :label="item.fullname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input
                            class="customer-address"
                            type="text"
                            :placeholder="$t('Client.Add.address_placeholder')"
                            v-model="form.workAddress">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="flex">
                    <el-form-item :label="$t('Client.Add.emergency_contact')">
                        <el-input
                            type="text"
                            v-model="form.contactName"
                            :placeholder="$t('Client.Add.emergency_contact_placeholder')">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Client.Add.contact_people')">
                        <el-input
                            type="text"
                            v-model="form.contactPhone"
                            :placeholder="$t('Client.Add.contact_people_placeholder')">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="customer-line"></div>
                <div class="flex">
                    <div>
                        <el-form-item :label="$t('Client.Add.purpose')">
                            <el-select
                                class="pr-2"
                                v-model="form.fitnessPurposeCode"
                                :placeholder="$t('Client.Add.purpose_placeholder')">
                                <el-option
                                    v-for="item in select.fitness"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="Number(item.code)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                <div class="customer-club">
                    <el-form-item :label="$t('Client.Add.club')">
                        <el-select
                            class="pr-2"
                            v-model="form.joinedClubCode"
                            :placeholder="$t('Common.please_choose')">
                            <el-option
                                v-for="item in select.club"
                                :key="item.code"
                                :label="item.name"
                                :value="Number(item.code)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Client.Add.member_is')" >
                        <el-select
                            class="pr-2"
                            v-model="form.wasFitnessMemberCode"
                            :placeholder="$t('Common.please_choose')">
                            <el-option
                                v-for="item in select.member"
                                :key="item.code"
                                :label="item.name"
                                :value="Number(item.code)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                    <div class="customer-brand">
                        <el-form-item :label="$t('Client.Add.brand')">
                            <el-input
                                type="text"
                                v-model="form.joinedClubBrand"
                                :placeholder="$t('Client.Add.brand_placeholder')">
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Client.Add.leave_reason')">
                            <el-select
                                class="pr-2"
                                v-model="form.leftReasonCode"
                                :placeholder="$t('Client.Add.leave_reason_placeholder')">
                                <el-option
                                    v-for="item in select.reasons"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="Number(item.code)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="customer-line"></div>
                <div class="flex">
                    <div>
                        <el-form-item :label="$t('Client.Add.customer_type')">
                            <el-select
                                class="pr-2"
                                v-model="form.categoryCode"
                                :placeholder="$t('Common.please_choose')">
                                <el-option
                                    v-for="item in select.category"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="Number(item.code)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Client.Add.marital_status')">
                            <el-select
                                class="pr-2"
                                v-model="form.marriageCode"
                                :placeholder="$t('Common.please_choose')">
                                <el-option
                                    v-for="item in select.marriage"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="Number(item.code)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item :label="$t('Client.Add.get_information_habits')">
                            <el-select
                                class="pr-2"
                                v-model="form.infoHabitCode"
                                :placeholder="$t('Common.please_choose')">
                                <el-option
                                    v-for="item in select.info"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="Number(item.code)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Client.Add.child_situation')">
                            <el-select
                                class="pr-2"
                                v-model="form.childrenCode"
                                :placeholder="$t('Common.please_choose')">
                                <el-option
                                    v-for="item in select.children"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="Number(item.code)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item :label="$t('Client.Add.personal_hobby')">
                            <el-select
                                class="pr-2"
                                v-model="form.personalHobbyCode"
                                :placeholder="$t('Common.please_choose')">
                                <el-option
                                    v-for="item in select.hobby"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="Number(item.code)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item :label="$t('Client.Add.customer_label')">
                    <el-checkbox-group class="add-client-checkbox" v-model="tagLabels">
                        <el-checkbox
                            v-for="(item, index) in select.labels"
                            :label="item.id"
                            :key="index"
                            class="client-checkbox-button"
                            style="margin-left: 10px"
                        >{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                    <!-- <span
                        @click="item.click = !item.click"
                        class="customer-label"
                        :class="item.click ? 'active' : ''"
                        v-for="(item, index) in select.labels"
                        :key="index">{{ item.name }}</span> -->
                </el-form-item>
                <el-form-item :label="$t('Common.remark')">
                    <el-input
                        type="textarea"
                        v-model="form.remark"
                        :placeholder="$t('Common.remark_placeholder')">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">{{ $t('Common.close') }}</el-button>
                <el-button @click="confirm" type="primary">{{ $t('Common.save') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import filterRole from '@/mixins/filterRole.js';
import { Dialog, Radio, DatePicker, RadioGroup, CheckboxButton } from 'element-ui';
import FileUpload from '../../components/base/FileUpload.vue';

export default {
    name: 'new-customer',
    components: {
        ElDialog: Dialog,
        ElRadio: Radio,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElCheckboxButton: CheckboxButton,
        FileUpload,
    },
    mixins: [filterRole],
    data() {
        return {
            tagLabels: [],
            form: {},
            tip: false,
            visible: false,
            changeFlag: false,
            tableData: {
                id: '',
                name: '',
                avatar: null,
                genderCode: 0,
                phone: '',
                age: null,
                birthday: '',
                wechat: '',
                provinceId: null,
                cityId: null,
                districtId: null,
                mshpSalesId: null,
                channelAttrCode: 0,
                channelSourceCode: 0,
                followLevelCode: 0,
                certTypeCode: 0,
                certNum: null,
                citizenship: null,
                nationCode: 0,
                career: null,
                email: null,
                homeProvinceId: null,
                homeCityId: null,
                homeDistrictId: null,
                homeAddress: null,
                companyName: null,
                companyPhone: null,
                workProvinceId: null,
                workCityId: null,
                workDistrictId: null,
                workAddress: null,
                contactName: null,
                contactPhone: null,
                fitnessPurposeCode: 0,
                joinedClubCode: -1,
                joinedClubBrand: '',
                wasFitnessMemberCode: -1,
                leftReasonCode: 0,
                categoryCode: 1,
                infoHabitCode: 0,
                personalHobbyCode: 0,
                marriageCode: 0,
                childrenCode: 0,
                remark: '',
                clientTagIds: [],
                cardNum: '',
                cardPhysicalId: null,
            },
            rules: {
                name: { type: 'string', required: true, message: this.$t('Common.name_placeholder') },
                genderCode: { type: 'number', required: true, message: this.$t('Common.gender_placeholder') },
                phone: { required: true, message: this.$t('Common.phone_placeholder'), trigger: 'blur' },
                channelAttrCode: { type: 'number', required: true, message: this.$t('Client.Add.attributes_placeholder') },
                channelSourceCode: { type: 'number', required: true, message: this.$t('Client.Add.get_attributes_placeholder') },
                mshpSalesId: { required: true, message: this.$t('Common.distribution_saler_placeholder') },
            },
            select: {
                gender: [],
                channel: [],
                channelCode: [],
                level: [],
                certType: [],
                nation: [],
                province: [],
                workCity: [],
                workDistrict: [],
                city: [],
                district: [],
                fitness: [],
                club: [],
                member: [],
                reasons: [],
                customers: [],
                marriage: [],
                info: [],
                children: [],
                hobby: [],
                labels: [],
                homeProvince: [],
                homeCity: [],
                homeDistrict: [],
            },
            searchText: '',
            sales: [],
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.sales;
            const arr = this.sales.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: null, nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        resetForm() {
            // 清空规则
            this.$refs.form.resetFields();
            // 清空form数据
            this.tip = false;
            this.form = {};
            this.select = {
                gender: [],
                channel: [],
                channelCode: [],
                level: [],
                certType: [],
                nation: [],
                province: [],
                workCity: [],
                workDistrict: [],
                city: [],
                district: [],
                fitness: [],
                club: [],
                member: [],
                reasons: [],
                customers: [],
                marriage: [],
                info: [],
                children: [],
                hobby: [],
                labels: [],
                category: [],
                homeProvince: [],
                homeCity: [],
                homeDistrict: [],
            };
            this.sales = [];
            this.searchText = '';
        },
        open(data) {
            this.fetchAll();
            this.fetchArea();
            this.fetchLabel();
            this.tagLabels = [];
            if (data) {
                this.fetchData(data);
                this.tip = true;
            } else {
                this.fetchSale();
            }
            this.visible = true;
        },
        confirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                if (this.validSelect()) this.handlePost();
            });
        },
        fetchData(id) {
            API.get(`client/${id}`)
            .then((res) => {
                this.form = res;
                this.tagLabels = res.clientTagIds;
                this.$delete(this.form, 'typeCode');
                this.$delete(this.form, 'type');
                this.$delete(this.form, 'point');
                if (this.form.provinceId) this.selectProvince(this.form.provinceId, 'origin');
                if (this.form.cityId) this.selectCity(this.form.cityId, 'origin', this.form.provinceId);
                if (this.form.workProvinceId) this.selectProvince(this.form.workProvinceId, 'work');
                if (this.form.workCityId) this.selectCity(this.form.workCityId, 'work', this.form.workProvinceId);
                if (this.form.homeCityId) this.selectCity(this.form.homeCityId, 'home', this.form.homeProvinceId);
                if (this.form.homeProvinceId) this.selectProvince(this.form.homeProvinceId, 'home');
                this.fetchSale(id);
            });
        },
        mapData() {
            for (const prop in this.form) {
                if (!this.tableData.hasOwnProperty(prop)) {
                    this.$delete(this.form, prop);
                }
            }
        },
        validSelect() {
            if (this.form.channelSourceCode === 0) $ele.$message.error(this.$t('Client.Add.get_attributes_placeholder'));
            else if (this.form.channelAttrCode === 0) $ele.$message.error(this.$t('Client.Add.attributes_placeholder'));
            else this.handlePost();
        },
        async handlePost() {
            this.form.clientTagIds = this.tagLabels;
            const keyword = this.form.phone;
            this.mapData();
            if (!this.form.id) {
                await API.post('client', this.form).then(res => {
                    if (res) {
                        $ele.$message.success(this.$t('Client.Add.add_success'));
                        this.$emit('input', 'update');
                        this.$emit('searchAppoint', keyword);
                    }
                });
            } else {
                await API.put(`client/${this.form.id}`, this.form).then(res => {
                    if (res) {
                        $ele.$message.success(this.$t('Client.Add.edit_success'));
                        this.$emit('input', 'update');
                    }
                });
            }
            this.visible = false;
            this.$emit('fetchData');
        },
        addImg(args) {
            this.form.avatar = args[0];
        },
        async fetchSale(id) {
            const ids = [5, 6];
            this.sales = await this.filterRole(null, ids, null, null, 'work');
            const salesId = this.sales.map(el => el.id);
            if (id && !salesId.includes(this.form.mshpSalesId)) {
                const array = [{
                    id: this.form.mshpSalesId,
                    nickname: this.form.mshpSalesNickname,
                }];
                this.sales = this.sales.concat(array);
            }
        },
        fetchAll() {
            API.get('constant/client').then(res => {
                this.select.gender = res.gender;
                this.select.channel = res.channelAttr;
                this.select.channelCode = res.channelSource;
                this.select.level = res.followLevel;
                this.select.certType = res.certType;
                this.select.nation = res.nation;
                this.select.fitness = res.fitnessPurpose;
                this.select.club = res.joinedClub;
                this.select.member = res.wasFitnessMember;
                this.select.reasons = res.leftReason;
                this.select.customers = res.clientType;
                this.select.marriage = res.marriage;
                this.select.info = res.infoHabit;
                this.select.children = res.children;
                this.select.hobby = res.personalHobby;
                this.select.category = res.category;
            });
        },
        changeDistrict(type, area) {
            if (area === 'province') {
                if (type === 'work') {
                    this.form.workCityId = null;
                    this.form.workDistrictId = null;
                }
                if (type === 'home') {
                    this.form.homeCityId = null;
                    this.form.homeDistrictId = null;
                }
                if (type === 'origin') {
                    this.form.cityId = null;
                    this.form.districtId = null;
                }
            }
            if (area === 'city') {
                if (type === 'origin') this.form.districtId = null;
                if (type === 'work') this.form.workDistrictId = null;
                if (type === 'home') this.form.homeDistrictId = null;
            }
        },
        // 获取省
        fetchArea() {
            API.get('district').then(res => {
                this.select.province = res.map(el => {
                    const item = {
                        id: el.id,
                        fullname: el.fullname,
                    };
                    return item;
                });
                this.select.homeProvince = this.select.province;
                this.select.workProvince = this.select.province;
            });
        },
        // 获取市
        selectProvince(val, type) {
            API.get(`district/city?provinceId=${val}`).then(res => {
                const cityTip = res.map(el => {
                    const item = {
                        id: el.id,
                        fullname: el.fullname,
                    };
                    return item;
                });
                if (type === 'home') this.select.homeCity = cityTip;
                if (type === 'work') this.select.workCity = cityTip;
                if (type === 'origin') this.select.city = cityTip;
            });
        },
        // 获取区
        selectCity(val, type, provinceId) {
            API.get('district/district', {
                params: {
                    provinceId: provinceId,
                    cityId: val,
                },
            }).then(res => {
                const distinctTip = res.map(el => {
                    const item = {
                        id: el.id,
                        fullname: el.fullname,
                    };
                    return item;
                });
                if (type === 'home') this.select.homeDistrict = distinctTip;
                if (type === 'work') this.select.workDistrict = distinctTip;
                if (type === 'origin') this.select.district = distinctTip;
            });
        },
        // 获取标签
        fetchLabel() {
            API.get('client-tag/list', {
                params: {
                    active: true,
                },
            }).then(res => {
                this.select.labels = res.map(el => {
                    el.click = false;
                    return el;
                });
            });
        },
    },
};
</script>

<style lang="scss">
.customer-dialog {
    .el-dialog {
        width: 940px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 88vh;
    }
    .add-client-checkbox {
        .el-checkbox__label {
            padding-right: 10px;
        }
    }
}
.new-customer-dialog {
    .el-dialog--center .el-dialog__body {
        padding: 25px 65px 0 25px;
    }
}
.avator-bg {
    width: 75px;
    height: 100px;
    background: #697a8e;
    color: #fff;
    margin-bottom: 10px;

    .iconfont {
        font-size: 50px;
    }

    .avatar {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
    }
}
.camera,
.abcd {
    text-align: center;
    background: #05abef;
    color: #fff;
    font-size: 12px;
    border-radius: 3px;
    width: 48.5%;
    height: 22px;
    line-height: 22px;
}
.customer-line {
    width: 100%;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 20px;
}
.customer-num {
    width: 360px;
}
.customer-email {
    width: 26%;
}
.customer-area {
    width: 20%;
}
.customer-address {
    width: 40% ;
}
.el-form-item__label {
    font-size: 13px;
}
.customer-club {
    .el-form-item__label {
        width: 180px !important;
    }
    .el-form-item {
        display: flex;
        justify-content: flex-start;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
}
textarea {
    width: 100%;
    height: 100px;
}
.customer-label {
    display: inline-block;
    font-size: 12px;
    color: grey;
    border: 1px solid #e6e6e6;
    border-radius: 24px;
    line-height: 1;
    padding: 6px 20px;
    cursor: pointer;
}
.active {
    color: #05abef;
    border-color: #05abef;
}
.client-checkbox-button {
    margin: 0px;
    padding-left: 10px;
    border: #dcdfe6 1px solid;
    border-radius: 20px;
    min-width: 100px;
}
</style>
